import { Bento } from "@/components/marketplace"
import type { BentoTile } from "@/components/marketplace/discovery/bento"
import type { BentoSection } from "@/features/feed/contract"
import { mapFeedProduct } from "@/features/feed/map-product"
import { resolveFeedLink } from "@/features/feed/resolve-link"
import { SectionFrame } from "@/features/feed/sections/SectionFrame"
import type { FeedSectionProps } from "@/features/feed/sections/types"

const spanOf = (span: number | undefined): 1 | 2 | 3 | 4 => (span === 2 || span === 3 || span === 4 ? span : 1)

export const BentoFeedSection = ({ section, context }: FeedSectionProps<BentoSection>) => {
  const tiles: BentoTile[] = section.data.tiles.map((tile) => ({
    id: tile.id,
    kind: tile.kind,
    span: spanOf(tile.span),
    label: tile.label,
    eyebrow: tile.eyebrow,
    title: tile.title,
    accent: tile.accent,
    sub: tile.sub,
    big: tile.big,
    image: tile.image?.url,
    product: tile.product ? mapFeedProduct(tile.product, context.countryCode) : undefined,
    href: tile.link ? resolveFeedLink(tile.link, context.countryCode, context.page) : undefined,
    serveId: tile.serveId,
  }))
  if (tiles.length === 0) return null
  return (
    <SectionFrame section={section} context={context} gut>
      <Bento tiles={tiles} />
    </SectionFrame>
  )
}
